import React from "react";
import Navbar from './Navbar'; 
import ServiceCard from './ServiceCard'; 
import ConsultationSection from './ConsultationSection';
import FooterSection from './FooterSection';
import MedicalVeterinary from './MedicalVeterinary';
import "./Service.css"; // Import custom styles
import bannerImage from "../assets/img/what_banner.png"; // Import your image path

const Service = () => {
  return (
    <>
      <Navbar />
      
      {/* Main content area with background color */}
      <main className="main-content">
        
        {/* Banner Section */}
        <section
          className="service-banner d-flex justify-content-center align-items-center text-center position-relative"
          style={{
            backgroundImage: `url(${bannerImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '500px',  // Adjustable height for the banner
            color: '#fff',  // White text for better contrast on the image
          }}
        >
          <div className="overlay-text position-absolute top-50 start-50 translate-middle">
            <h1 className="morrestact-font text-black text-start">Comprehensive Breast <br/>Infrared Services</h1>
            <p className="popins-font text-black text-start">
              We provide advanced thermal imaging solutions for early detection, <br/>research, and education. Explore our wide range of services.
            </p>
          </div>
        </section>

        {/* Service Description */}
        <section className="service-description py-5">
          <div className="container">
            <p className="text-black">
              Breast Infrared is a revolutionary, non-invasive method for early detection and preventive healthcare. Our expert team offers a range of services, from clinical applications to training and research, ensuring the best care and support for your needs.
            </p>
          </div>
        </section>

        {/* ServiceCard component below the banner */}
        <ServiceCard />
        <MedicalVeterinary />
        {/* Consultation Section */}
        <ConsultationSection />
        
        
        {/* Footer Section */}
        <FooterSection />
        
      </main>
    </>
  );
};

export default Service;
